import { TagVolumeDiscountV2 } from './TagVolumeDiscountV2';
export { TagVolumeDiscountV2 };